import React from "react";
import { StyledQuestion } from "../../styles";
import { FunctionalButton } from "../../../../../components/functionalButton";
import { ESubInfo } from "../types";
import { StyledTextarea } from "../styles";

type RemarksSectionProps = {
  esubData: ESubInfo;
  setESubData: (field: string, value: string) => void;
  isMobile: boolean;
  handleNext: () => void;
  panel: number;
  setPanel: (panel: number) => void;
  setIsLastPanel: (isLastPanel: boolean) => void;
  setPreviousStepPanel: (prevStepPanel: number) => void;
};

export const RemarksSection = ({
  esubData,
  setESubData,
  isMobile,
  handleNext,
  panel,
  setPanel,
  setIsLastPanel,
  setPreviousStepPanel,
}: RemarksSectionProps) => {
  setIsLastPanel(true);
  setPreviousStepPanel(6);
  return (
    <>
      <StyledQuestion isMobile={isMobile} width="650px">
        Any Additional Remarks for the Carrier?
      </StyledQuestion>
      <Textarea
        value={esubData?.bond_details?.remarks ?? ""}
        setValue={(e) => setESubData("bond_details.remarks", e)}
      />
      <FunctionalButton
        buttonTitle="Next"
        handleButton={() => {
          handleNext();
          setPanel(1);
        }}
        width={undefined}
        height={undefined}
        isReversedColor={undefined}
        marginRight={undefined}
        marginLeft={undefined}
        marginTop={"40px"}
        marginBottom={undefined}
        fontSize={undefined}
        disabled={undefined}
        icon={undefined}
        hasBoxShadow={undefined}
        frontIcon={undefined}
        weight={undefined}
        borderColor={undefined}
        selected={undefined}
      />
    </>
  );
};

const Textarea = ({
  value,
  setValue,
  placeholder = "Enter your text...",
  disabled = false,
  ...props
}) => {
  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <StyledTextarea
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      {...props}
    />
  );
};

export default Textarea;
